// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__12yOo","gfeWrapper":"CalendarEvent_gfeWrapper__3IJYA"};